"use client";

import { FaqBlock as FaqBlockTypes } from "@/payload-types";
import { RichText } from "@payloadcms/richtext-lexical/react";
import { useState } from "react";

export const FaqAccordion = (props: FaqBlockTypes) => {
  const { title, faqs } = props;
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div className={`container py-8 gap-8`}>
      {/*title && image && typeof image == 'object' && <SectionTitle title={title} />*/}
      <h1 className="mb-10 mt-10">{title}</h1>
      <div className="divide-y border-y divide-[#AB9556] border-[#AB9556]">
        {faqs &&
          faqs.map((item, index) => (
            <div key={item.id} className="py-9">
              <button
                className="flex justify-between w-full text-left text-lg font-semibold focus:outline-none"
                onClick={() => toggleAccordion(index)}
              >
                <span>{item.faq.question}</span>
                <span className="text-xl">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>

              <div
                className={`mt-2 transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === index
                    ? "max-h-screen opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="pt-2 text-gray-700 text-sm">
                  <RichText data={item.faq.answer} />
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
